export const phoneNumbers = [
  {
    name: 'Afghanistan',
    dial_code: '+93',
    code: 'AF',
    region: 'Asia',
    example: '70 123 4567',
  },
  // {
  //   name: 'Aland Islands',
  //   dial_code: '+358',
  //   code: 'AX',
  //   region: 'Europe',
  // },
  {
    name: 'Albania',
    dial_code: '+355',
    code: 'AL',
    region: 'Europe',
    example: '67 212 3456',
  },
  {
    name: 'Algeria',
    dial_code: '+213',
    code: 'DZ',
    region: 'Africa',
    example: '551 23 45 67',
  },
  {
    name: 'American Samoa',
    dial_code: '+1684',
    code: 'AS',
    region: 'Oceania',
    example: '733 1234',
  },
  {
    name: 'Andorra',
    dial_code: '+376',
    code: 'AD',
    region: 'Europe',
    example: '312 345',
  },
  {
    name: 'Angola',
    dial_code: '+244',
    code: 'AO',
    region: 'Africa',
    example: '923 123 456',
  },
  {
    name: 'Anguilla',
    dial_code: '+1264',
    code: 'AI',
    region: 'North America',
    example: '235 1234',
  },
  // {
  //   name: 'Antarctica',
  //   dial_code: '+672',
  //   code: 'AQ',
  //   region: 'Antarctica',
  // },
  {
    name: 'Antigua and Barbuda',
    dial_code: '+1268',
    code: 'AG',
    region: 'North America',
    example: '464 1234',
  },
  {
    name: 'Argentina',
    dial_code: '+54',
    code: 'AR',
    region: 'South America',
    example: '11 2345-6789',
  },
  {
    name: 'Armenia',
    dial_code: '+374',
    code: 'AM',
    region: 'Asia',
    example: '77 123456',
  },
  // {
  //   name: 'Aruba',
  //   dial_code: '+297',
  //   code: 'AW',
  //   region: 'North America',
  // },
  {
    name: 'Australia',
    dial_code: '+61',
    code: 'AU',
    region: 'Oceania',
    example: '412 345 678',
  },
  {
    name: 'Austria',
    dial_code: '+43',
    code: 'AT',
    region: 'Europe',
    example: '664 123456',
  },
  {
    name: 'Azerbaijan',
    dial_code: '+994',
    code: 'AZ',
    region: 'Asia',
    example: '40 123 45 67',
  },
  {
    name: 'Bahamas',
    dial_code: '+1242',
    code: 'BS',
    region: 'North America',
    example: '359 1234',
  },
  {
    name: 'Bahrain',
    dial_code: '+973',
    code: 'BH',
    region: 'Asia',
    example: '3600 1234',
  },
  {
    name: 'Bangladesh',
    dial_code: '+880',
    code: 'BD',
    region: 'Asia',
    example: '1812 345678',
  },
  {
    name: 'Barbados',
    dial_code: '+1246',
    code: 'BB',
    region: 'North America',
    example: '250 1234',
  },
  {
    name: 'Belarus',
    dial_code: '+375',
    code: 'BY',
    region: 'Europe',
    example: '29 123 45 67',
  },
  {
    name: 'Belgium',
    dial_code: '+32',
    code: 'BE',
    region: 'Europe',
    example: '470 12 34 56',
  },
  {
    name: 'Belize',
    dial_code: '+501',
    code: 'BZ',
    region: 'North America',
    example: '622 1234',
  },
  {
    name: 'Benin',
    dial_code: '+229',
    code: 'BJ',
    region: 'Africa',
    example: '90 01 12 34',
  },
  {
    name: 'Bermuda',
    dial_code: '+1441',
    code: 'BM',
    region: 'North America',
    example: '370 1234',
  },
  {
    name: 'Bhutan',
    dial_code: '+975',
    code: 'BT',
    region: 'Asia',
    example: '17 12 34 56',
  },
  {
    name: 'Bolivia',
    dial_code: '+591',
    code: 'BO',
    region: 'South America',
    example: '71234567',
  },
  {
    name: 'Bosnia and Herzegovina',
    dial_code: '+387',
    code: 'BA',
    region: 'Europe',
    example: '61 123 456',
  },
  {
    name: 'Botswana',
    dial_code: '+267',
    code: 'BW',
    region: 'Africa',
    example: '71 123 456',
  },
  {
    name: 'Brazil',
    dial_code: '+55',
    code: 'BR',
    region: 'South America',
    example: '11 91234-5678',
  },
  // {
  //   name: 'British Indian Ocean Territory',
  //   dial_code: '+246',
  //   code: 'IO',
  //   region: 'Asia',
  // },
  {
    name: 'Brunei Darussalam',
    dial_code: '+673',
    code: 'BN',
    region: 'Asia',
    example: '712 3456',
  },
  {
    name: 'Bulgaria',
    dial_code: '+359',
    code: 'BG',
    region: 'Europe',
    example: '48 123 456',
  },
  {
    name: 'Burkina Faso',
    dial_code: '+226',
    code: 'BF',
    region: 'Africa',
    example: '70 12 34 56',
  },
  {
    name: 'Burundi',
    dial_code: '+257',
    code: 'BI',
    region: 'Africa',
    example: '79 56 12 34',
  },
  {
    name: 'Cambodia',
    dial_code: '+855',
    code: 'KH',
    region: 'Asia',
    example: '91 234 567',
  },
  {
    name: 'Cameroon',
    dial_code: '+237',
    code: 'CM',
    region: 'Africa',
    example: '6 71 23 45 67',
  },
  {
    name: 'Canada',
    dial_code: '+1',
    code: 'CA',
    region: 'North America',
    example: '(555) 123-4567',
  },
  {
    name: 'Cape Verde',
    dial_code: '+238',
    code: 'CV',
    region: 'Africa',
    example: '991 12 34',
  },
  {
    name: 'Cayman Islands',
    dial_code: '+1345',
    code: 'KY',
    region: 'North America',
    example: '323 1234',
  },
  {
    name: 'Central African Republic',
    dial_code: '+236',
    code: 'CF',
    region: 'Africa',
    example: '70 01 23 45',
  },
  {
    name: 'Chad',
    dial_code: '+235',
    code: 'TD',
    region: 'Africa',
    example: '63 01 23 45',
  },
  {
    name: 'Chile',
    dial_code: '+56',
    code: 'CL',
    region: 'South America',
    example: '9 6123 4567',
  },
  {
    name: 'China',
    dial_code: '+86',
    code: 'CN',
    region: 'Asia',
    example: '131 2345 6789',
  },
  {
    name: 'Christmas Island',
    dial_code: '+61',
    code: 'CX',
    region: 'Oceania',
    example: '412 345 678',
  },
  // {
  //   name: 'Cocos (Keeling) Islands',
  //   dial_code: '+61',
  //   code: 'CC',
  //   region: 'Oceania',
  // },
  {
    name: 'Colombia',
    dial_code: '+57',
    code: 'CO',
    region: 'South America',
    example: '321 1234567',
  },
  {
    name: 'Comoros',
    dial_code: '+269',
    code: 'KM',
    region: 'Africa',
    example: '321 23 45',
  },
  {
    name: 'Congo',
    dial_code: '+242',
    code: 'CG',
    region: 'Africa',
    example: '06 123 4567',
  },
  {
    name: 'Congo, The Democratic Republic of the Congo',
    dial_code: '+243',
    code: 'CD',
    region: 'Africa',
    example: '991 234 567',
  },
  {
    name: 'Cook Islands',
    dial_code: '+682',
    code: 'CK',
    region: 'Oceania',
    example: '71 234',
  },
  {
    name: 'Costa Rica',
    dial_code: '+506',
    code: 'CR',
    region: 'North America',
    example: '8312 3456',
  },
  {
    name: "Cote d'Ivoire",
    dial_code: '+225',
    code: 'CI',
    region: 'Africa',
    example: '01 23 45 67',
  },
  {
    name: 'Croatia',
    dial_code: '+385',
    code: 'HR',
    region: 'Europe',
    example: '91 234 5678',
  },
  {
    name: 'Cuba',
    dial_code: '+53',
    code: 'CU',
    region: 'North America',
    example: '5 1234567',
  },
  {
    name: 'Cyprus',
    dial_code: '+357',
    code: 'CY',
    region: 'Asia',
    example: '96 123456',
  },
  {
    name: 'Czech Republic',
    dial_code: '+420',
    code: 'CZ',
    region: 'Europe',
    example: '601 123 456',
  },
  {
    name: 'Denmark',
    dial_code: '+45',
    code: 'DK',
    region: 'Europe',
    example: '32 12 34 56',
  },
  {
    name: 'Djibouti',
    dial_code: '+253',
    code: 'DJ',
    region: 'Africa',
    example: '77 83 10 01',
  },
  {
    name: 'Dominica',
    dial_code: '+1767',
    code: 'DM',
    region: 'North America',
    example: '225 1234',
  },
  {
    name: 'Dominican Republic',
    dial_code: '+1849',
    code: 'DO',
    region: 'North America',
    example: '234 5678',
  },
  {
    name: 'Ecuador',
    dial_code: '+593',
    code: 'EC',
    region: 'South America',
    example: '99 123 4567',
  },
  {
    name: 'Egypt',
    dial_code: '+20',
    code: 'EG',
    region: 'Africa',
    example: '100 123 4567',
  },
  {
    name: 'El Salvador',
    dial_code: '+503',
    code: 'SV',
    region: 'North America',
    example: '7012 3456',
  },
  {
    name: 'Equatorial Guinea',
    dial_code: '+240',
    code: 'GQ',
    region: 'Africa',
    example: '222 123 456',
  },
  {
    name: 'Eritrea',
    dial_code: '+291',
    code: 'ER',
    region: 'Africa',
    example: '7 123 456',
  },
  {
    name: 'Estonia',
    dial_code: '+372',
    code: 'EE',
    region: 'Europe',
    example: '5123 4567',
  },
  {
    name: 'Ethiopia',
    dial_code: '+251',
    code: 'ET',
    region: 'Africa',
    example: '91 123 4567',
  },
  {
    name: 'Falkland Islands',
    dial_code: '+500',
    code: 'FK',
    region: 'South America',
    example: '51234',
  },
  {
    name: 'Faroe Islands',
    dial_code: '+298',
    code: 'FO',
    region: 'Europe',
    example: '211234',
  },
  {
    name: 'Fiji',
    dial_code: '+679',
    code: 'FJ',
    region: 'Oceania',
    example: '701 2345',
  },
  {
    name: 'Finland',
    dial_code: '+358',
    code: 'FI',
    region: 'Europe',
    example: '41 2345678',
  },
  {
    name: 'France',
    dial_code: '+33',
    code: 'FR',
    region: 'Europe',
    example: '6 12 34 56 78',
  },
  {
    name: 'French Guiana',
    dial_code: '+594',
    code: 'GF',
    region: 'South America',
    example: '694 20 12 34',
  },
  {
    name: 'French Polynesia',
    dial_code: '+689',
    code: 'PF',
    region: 'Oceania',
    example: '87 12 34 56',
  },
  {
    name: 'Gabon',
    dial_code: '+241',
    code: 'GA',
    region: 'Africa',
    example: '06 03 12 34',
  },
  {
    name: 'Gambia',
    dial_code: '+220',
    code: 'GM',
    region: 'Africa',
    example: '301 2345',
  },
  {
    name: 'Georgia',
    dial_code: '+995',
    code: 'GE',
    region: 'Asia',
    example: '555 12 34 56',
  },
  {
    name: 'Germany',
    dial_code: '+49',
    code: 'DE',
    region: 'Europe',
    example: '151 23456789',
  },
  {
    name: 'Ghana',
    dial_code: '+233',
    code: 'GH',
    region: 'Africa',
    example: '23 123 4567',
  },
  {
    name: 'Gibraltar',
    dial_code: '+350',
    code: 'GI',
    region: 'Europe',
    example: '57123456',
  },
  {
    name: 'Greece',
    dial_code: '+30',
    code: 'GR',
    region: 'Europe',
    example: '691 234 5678',
  },
  {
    name: 'Greenland',
    dial_code: '+299',
    code: 'GL',
    region: 'North America',
    example: '22 12 34',
  },
  {
    name: 'Grenada',
    dial_code: '+1473',
    code: 'GD',
    region: 'North America',
    example: '403 1234',
  },
  {
    name: 'Guadeloupe',
    dial_code: '+590',
    code: 'GP',
    region: 'North America',
    example: '690 30 12 34',
  },
  {
    name: 'Guam',
    dial_code: '+1671',
    code: 'GU',
    region: 'Oceania',
    example: '300 1234',
  },
  {
    name: 'Guatemala',
    dial_code: '+502',
    code: 'GT',
    region: 'North America',
    example: '5123 4567',
  },
  // {
  //   name: 'Guernsey',
  //   dial_code: '+44',
  //   code: 'GG',
  //   region: 'Europe',
  // },
  {
    name: 'Guinea',
    dial_code: '+224',
    code: 'GN',
    region: 'Africa',
    example: '601 12 34 56',
  },
  {
    name: 'Guinea-Bissau',
    dial_code: '+245',
    code: 'GW',
    region: 'Africa',
    example: '955 012 345',
  },
  {
    name: 'Guyana',
    dial_code: '+592',
    code: 'GY',
    region: 'South America',
    example: '609 1234',
  },
  {
    name: 'Haiti',
    dial_code: '+509',
    code: 'HT',
    region: 'North America',
    example: '34 10 1234',
  },
  {
    name: 'Vatican City',
    dial_code: '+379',
    code: 'VA',
    region: 'Europe',
    example: '06 698 12345',
  },
  {
    name: 'Honduras',
    dial_code: '+504',
    code: 'HN',
    region: 'North America',
    example: '9123 4567',
  },
  {
    name: 'Hong Kong',
    dial_code: '+852',
    code: 'HK',
    region: 'Asia',
    example: '5123 4567',
  },
  {
    name: 'Hungary',
    dial_code: '+36',
    code: 'HU',
    region: 'Europe',
    example: '20 123 4567',
  },
  {
    name: 'Iceland',
    dial_code: '+354',
    code: 'IS',
    region: 'Europe',
    example: '611 1234',
  },
  {
    name: 'India',
    dial_code: '+91',
    code: 'IN',
    region: 'Asia',
    example: '98765 43210',
  },
  {
    name: 'Indonesia',
    dial_code: '+62',
    code: 'ID',
    region: 'Asia',
    example: '812 345 6789',
  },
  {
    name: 'Iran',
    dial_code: '+98',
    code: 'IR',
    region: 'Asia',
    example: '912 345 6789',
  },
  {
    name: 'Iraq',
    dial_code: '+964',
    code: 'IQ',
    region: 'Asia',
    example: '791 234 5678',
  },
  {
    name: 'Ireland',
    dial_code: '+353',
    code: 'IE',
    region: 'Europe',
    example: '85 012 3456',
  },
  {
    name: 'Isle of Man',
    dial_code: '+44',
    code: 'IM',
    region: 'Europe',
    example: '7924 123456',
  },
  {
    name: 'Israel',
    dial_code: '+972',
    code: 'IL',
    region: 'Asia',
    example: '50 123 4567',
  },
  {
    name: 'Italy',
    dial_code: '+39',
    code: 'IT',
    region: 'Europe',
    example: '312 345 6789',
  },
  {
    name: 'Jamaica',
    dial_code: '+1876',
    code: 'JM',
    region: 'North America',
    example: '210 1234',
  },
  {
    name: 'Japan',
    dial_code: '+81',
    code: 'JP',
    region: 'Asia',
    example: '90-1234-5678',
  },
  {
    name: 'Jersey',
    dial_code: '+44',
    code: 'JE',
    region: 'Europe',
    example: '7797 123456',
  },
  {
    name: 'Jordan',
    dial_code: '+962',
    code: 'JO',
    region: 'Asia',
    example: '7 9012 3456',
  },
  {
    name: 'Kazakhstan',
    dial_code: '+7',
    code: 'KZ',
    region: 'Asia',
    example: '771 123 4567',
  },
  {
    name: 'Kenya',
    dial_code: '+254',
    code: 'KE',
    region: 'Africa',
    example: '712 123456',
  },
  {
    name: 'Kiribati',
    dial_code: '+686',
    code: 'KI',
    region: 'Oceania',
    example: '72012345',
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    dial_code: '+850',
    code: 'KP',
    region: 'Asia',
    example: '192 123 4567',
  },
  {
    name: 'Korea, Republic of South Korea',
    dial_code: '+82',
    code: 'KR',
    region: 'Asia',
    example: '10-1234-5678',
  },
  {
    name: 'Kuwait',
    dial_code: '+965',
    code: 'KW',
    region: 'Asia',
    example: '500 12345',
  },
  {
    name: 'Kyrgyzstan',
    dial_code: '+996',
    code: 'KG',
    region: 'Asia',
    example: '700 123 456',
  },
  {
    name: 'Laos',
    dial_code: '+856',
    code: 'LA',
    region: 'Asia',
    example: '20 23 123 456',
  },
  {
    name: 'Latvia',
    dial_code: '+371',
    code: 'LV',
    region: 'Europe',
    example: '21 234 567',
  },
  {
    name: 'Lebanon',
    dial_code: '+961',
    code: 'LB',
    region: 'Asia',
    example: '71 123 456',
  },
  {
    name: 'Lesotho',
    dial_code: '+266',
    code: 'LS',
    region: 'Africa',
    example: '5012 3456',
  },
  {
    name: 'Liberia',
    dial_code: '+231',
    code: 'LR',
    region: 'Africa',
    example: '77 012 3456',
  },
  {
    name: 'Libya',
    dial_code: '+218',
    code: 'LY',
    region: 'Africa',
    example: '91 2345678',
  },
  {
    name: 'Liechtenstein',
    dial_code: '+423',
    code: 'LI',
    region: 'Europe',
    example: '660 234 567',
  },
  {
    name: 'Lithuania',
    dial_code: '+370',
    code: 'LT',
    region: 'Europe',
    example: '612 34567',
  },
  {
    name: 'Luxembourg',
    dial_code: '+352',
    code: 'LU',
    region: 'Europe',
    example: '628 123 456',
  },
  // {
  //   name: 'Macao',
  //   dial_code: '+853',
  //   code: 'MO',
  //   region: 'Asia',
  // },
  {
    name: 'North Macedonia',
    dial_code: '+389',
    code: 'MK',
    region: 'Europe',
    example: '72 345 678',
  },
  {
    name: 'Madagascar',
    dial_code: '+261',
    code: 'MG',
    region: 'Africa',
    example: '32 12 345 67',
  },
  {
    name: 'Malawi',
    dial_code: '+265',
    code: 'MW',
    region: 'Africa',
    example: '991 23 45 67',
  },
  {
    name: 'Malaysia',
    dial_code: '+60',
    code: 'MY',
    region: 'Asia',
    example: '12 345 6789',
  },
  {
    name: 'Maldives',
    dial_code: '+960',
    code: 'MV',
    region: 'Asia',
    example: '771 2345',
  },
  {
    name: 'Mali',
    dial_code: '+223',
    code: 'ML',
    region: 'Africa',
    example: '65 01 23 45',
  },
  {
    name: 'Malta',
    dial_code: '+356',
    code: 'MT',
    region: 'Europe',
    example: '9696 1234',
  },
  {
    name: 'Marshall Islands',
    dial_code: '+692',
    code: 'MH',
    region: 'Oceania',
    example: '235 1234',
  },
  {
    name: 'Martinique',
    dial_code: '+596',
    code: 'MQ',
    region: 'North America',
    example: '696 20 12 34',
  },
  {
    name: 'Mauritania',
    dial_code: '+222',
    code: 'MR',
    region: 'Africa',
    example: '22 12 34 56',
  },
  {
    name: 'Mauritius',
    dial_code: '+230',
    code: 'MU',
    region: 'Africa',
    example: '5251 2345',
  },
  {
    name: 'Mayotte',
    dial_code: '+262',
    code: 'YT',
    region: 'Africa',
    example: '639 12 34 56',
  },
  {
    name: 'Mexico',
    dial_code: '+52',
    code: 'MX',
    region: 'North America',
    example: '55 1234 5678',
  },
  {
    name: 'Micronesia, Federated States of Micronesia',
    dial_code: '+691',
    code: 'FM',
    region: 'Oceania',
    example: '350 1234',
  },
  {
    name: 'Moldova',
    dial_code: '+373',
    code: 'MD',
    region: 'Europe',
    example: '621 12 345',
  },
  {
    name: 'Monaco',
    dial_code: '+377',
    code: 'MC',
    region: 'Europe',
    example: '6 12 34 56 78',
  },
  {
    name: 'Mongolia',
    dial_code: '+976',
    code: 'MN',
    region: 'Asia',
    example: '8812 3456',
  },
  {
    name: 'Montenegro',
    dial_code: '+382',
    code: 'ME',
    region: 'Europe',
    example: '67 123 456',
  },
  {
    name: 'Montserrat',
    dial_code: '+1664',
    code: 'MS',
    region: 'North America',
    example: '492 1234',
  },
  {
    name: 'Morocco',
    dial_code: '+212',
    code: 'MA',
    region: 'Africa',
    example: '650-123456',
  },
  {
    name: 'Mozambique',
    dial_code: '+258',
    code: 'MZ',
    region: 'Africa',
    example: '82 123 4567',
  },
  {
    name: 'Myanmar',
    dial_code: '+95',
    code: 'MM',
    region: 'Asia',
    example: '9 212 3456',
  },
  {
    name: 'Namibia',
    dial_code: '+264',
    code: 'NA',
    region: 'Africa',
    example: '81 123 4567',
  },
  {
    name: 'Nauru',
    dial_code: '+674',
    code: 'NR',
    region: 'Oceania',
    example: '555 1234',
  },
  {
    name: 'Nepal',
    dial_code: '+977',
    code: 'NP',
    region: 'Asia',
    example: '984-1234567',
  },
  {
    name: 'Netherlands',
    dial_code: '+31',
    code: 'NL',
    region: 'Europe',
    example: '6 12345678',
  },
  // {
  //   name: 'Netherlands Antilles',
  //   dial_code: '+599',
  //   code: 'AN',
  //   region: 'North America',
  // },
  {
    name: 'New Caledonia',
    dial_code: '+687',
    code: 'NC',
    region: 'Oceania',
    example: '75 12 34',
  },
  {
    name: 'New Zealand',
    dial_code: '+64',
    code: 'NZ',
    region: 'Oceania',
    example: '21 123 4567',
  },
  {
    name: 'Nicaragua',
    dial_code: '+505',
    code: 'NI',
    region: 'North America',
    example: '8123 4567',
  },
  {
    name: 'Niger',
    dial_code: '+227',
    code: 'NE',
    region: 'Africa',
    example: '93 12 34 56',
  },
  {
    name: 'Nigeria',
    dial_code: '+234',
    code: 'NG',
    region: 'Africa',
    example: '802 123 4567',
  },
  {
    name: 'Niue',
    dial_code: '+683',
    code: 'NU',
    region: 'Oceania',
    example: '1234',
  },
  {
    name: 'Norfolk Island',
    dial_code: '+672',
    code: 'NF',
    region: 'Oceania',
    example: '3 81234',
  },
  {
    name: 'Northern Mariana Islands',
    dial_code: '+1670',
    code: 'MP',
    region: 'Oceania',
    example: '234 5678',
  },
  {
    name: 'Norway',
    dial_code: '+47',
    code: 'NO',
    region: 'Europe',
    example: '406 12 345',
  },
  {
    name: 'Oman',
    dial_code: '+968',
    code: 'OM',
    region: 'Asia',
    example: '9212 3456',
  },
  {
    name: 'Pakistan',
    dial_code: '+92',
    code: 'PK',
    region: 'Asia',
    example: '301 2345678',
  },
  {
    name: 'Palau',
    dial_code: '+680',
    code: 'PW',
    region: 'Oceania',
    example: '620 1234',
  },
  {
    name: 'Palestinian Territory, Occupied',
    dial_code: '+970',
    code: 'PS',
    region: 'Asia',
    example: '59 123 4567',
  },
  {
    name: 'Panama',
    dial_code: '+507',
    code: 'PA',
    region: 'North America',
    example: '6123-4567',
  },
  {
    name: 'Papua New Guinea',
    dial_code: '+675',
    code: 'PG',
    region: 'Oceania',
    example: '7012 3456',
  },
  {
    name: 'Paraguay',
    dial_code: '+595',
    code: 'PY',
    region: 'South America',
    example: '961 456789',
  },
  {
    name: 'Peru',
    dial_code: '+51',
    code: 'PE',
    region: 'South America',
    example: '912 345 678',
  },
  {
    name: 'Philippines',
    dial_code: '+63',
    code: 'PH',
    region: 'Asia',
    example: '905 123 4567',
  },
  {
    name: 'Pitcairn',
    dial_code: '+872',
    code: 'PN',
    region: 'Oceania',
    example: '51 234',
  },
  {
    name: 'Poland',
    dial_code: '+48',
    code: 'PL',
    region: 'Europe',
    example: '512 345 678',
  },
  {
    name: 'Portugal',
    dial_code: '+351',
    code: 'PT',
    region: 'Europe',
    example: '912 345 678',
  },
  {
    name: 'Puerto Rico',
    dial_code: '+1939',
    code: 'PR',
    region: 'North America',
    example: '234 5678',
  },
  {
    name: 'Qatar',
    dial_code: '+974',
    code: 'QA',
    region: 'Asia',
    example: '3312 3456',
  },
  {
    name: 'Romania',
    dial_code: '+40',
    code: 'RO',
    region: 'Europe',
    example: '712 034 567',
  },
  {
    name: 'Russia',
    dial_code: '+7',
    code: 'RU',
    region: 'Europe',
    example: '912 123-45-67',
  },
  {
    name: 'Rwanda',
    dial_code: '+250',
    code: 'RW',
    region: 'Africa',
    example: '720 123 456',
  },
  // {
  //   name: 'Reunion',
  //   dial_code: '+262',
  //   code: 'RE',
  //   region: 'Africa',
  // },
  // {
  //   name: 'Saint Barthelemy',
  //   dial_code: '+590',
  //   code: 'BL',
  //   region: 'North America',
  // },
  {
    name: 'Saint Helena, Ascension and Tristan Da Cunha',
    dial_code: '+290',
    code: 'SH',
    region: 'Africa',
    example: '51234',
  },
  {
    name: 'Saint Kitts and Nevis',
    dial_code: '+1869',
    code: 'KN',
    region: 'North America',
    example: '765 1234',
  },
  {
    name: 'Saint Lucia',
    dial_code: '+1758',
    code: 'LC',
    region: 'North America',
    example: '284 5678',
  },
  // {
  //   name: 'Saint Martin',
  //   dial_code: '+590',
  //   code: 'MF',
  //   region: 'North America',
  // },
  // {
  //   name: 'Saint Pierre and Miquelon',
  //   dial_code: '+508',
  //   code: 'PM',
  //   region: 'North America',
  // },
  {
    name: 'Saint Vincent and the Grenadines',
    dial_code: '+1784',
    code: 'VC',
    region: 'North America',
    example: '430 1234',
  },
  {
    name: 'Samoa',
    dial_code: '+685',
    code: 'WS',
    region: 'Oceania',
    example: '72 12345',
  },
  {
    name: 'San Marino',
    dial_code: '+378',
    code: 'SM',
    region: 'Europe',
    example: '66 66 12 12',
  },
  {
    name: 'Sao Tome and Principe',
    dial_code: '+239',
    code: 'ST',
    region: 'Africa',
    example: '981 2345',
  },
  {
    name: 'Saudi Arabia',
    dial_code: '+966',
    code: 'SA',
    region: 'Asia',
    example: '50 123 4567',
  },
  {
    name: 'Senegal',
    dial_code: '+221',
    code: 'SN',
    region: 'Africa',
    example: '70 123 45 67',
  },
  {
    name: 'Serbia',
    dial_code: '+381',
    code: 'RS',
    region: 'Europe',
    example: '60 1234567',
  },
  {
    name: 'Seychelles',
    dial_code: '+248',
    code: 'SC',
    region: 'Africa',
    example: '2 510 123',
  },
  {
    name: 'Sierra Leone',
    dial_code: '+232',
    code: 'SL',
    region: 'Africa',
    example: '25 123456',
  },
  {
    name: 'Singapore',
    dial_code: '+65',
    code: 'SG',
    region: 'Asia',
    example: '8123 4567',
  },
  {
    name: 'Slovakia',
    dial_code: '+421',
    code: 'SK',
    region: 'Europe',
    example: '912 123 456',
  },
  {
    name: 'Slovenia',
    dial_code: '+386',
    code: 'SI',
    region: 'Europe',
    example: '31 234 567',
  },
  {
    name: 'Solomon Islands',
    dial_code: '+677',
    code: 'SB',
    region: 'Oceania',
    example: '74 21234',
  },
  {
    name: 'Somalia',
    dial_code: '+252',
    code: 'SO',
    region: 'Africa',
    example: '7 1123456',
  },
  {
    name: 'South Africa',
    dial_code: '+27',
    code: 'ZA',
    region: 'Africa',
    example: '71 123 4567',
  },
  {
    name: 'South Sudan',
    dial_code: '+211',
    code: 'SS',
    region: 'Africa',
    example: '977 123 456',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    dial_code: '+500',
    code: 'GS',
    region: 'South America',
    example: '51234',
  },
  {
    name: 'Spain',
    dial_code: '+34',
    code: 'ES',
    region: 'Europe',
    example: '612 34 56 78',
  },
  {
    name: 'Sri Lanka',
    dial_code: '+94',
    code: 'LK',
    region: 'Asia',
    example: '71 234 5678',
  },
  {
    name: 'Sudan',
    dial_code: '+249',
    code: 'SD',
    region: 'Africa',
    example: '91 123 4567',
  },
  {
    name: 'Suriname',
    dial_code: '+597',
    code: 'SR',
    region: 'South America',
    example: '741 2345',
  },
  {
    name: 'Svalbard and Jan Mayen',
    dial_code: '+47',
    code: 'SJ',
    region: 'Europe',
    example: '79 12 34 56',
  },
  {
    name: 'Eswatini',
    dial_code: '+268',
    code: 'SZ',
    region: 'Africa',
    example: '7612 3456',
  },
  {
    name: 'Sweden',
    dial_code: '+46',
    code: 'SE',
    region: 'Europe',
    example: '70 123 45 67',
  },
  {
    name: 'Switzerland',
    dial_code: '+41',
    code: 'CH',
    region: 'Europe',
    example: '78 123 45 67',
  },
  {
    name: 'Syria',
    dial_code: '+963',
    code: 'SY',
    region: 'Asia',
    example: '944 567 890',
  },
  {
    name: 'Taiwan',
    dial_code: '+886',
    code: 'TW',
    region: 'Asia',
    example: '912 345 678',
  },
  {
    name: 'Tajikistan',
    dial_code: '+992',
    code: 'TJ',
    region: 'Asia',
    example: '917 12 3456',
  },
  {
    name: 'Tanzania',
    dial_code: '+255',
    code: 'TZ',
    region: 'Africa',
    example: '621 234 567',
  },
  {
    name: 'Thailand',
    dial_code: '+66',
    code: 'TH',
    region: 'Asia',
    example: '81 234 5678',
  },
  {
    name: 'Timor-Leste',
    dial_code: '+670',
    code: 'TL',
    region: 'Asia',
    example: '7721 2345',
  },
  {
    name: 'Togo',
    dial_code: '+228',
    code: 'TG',
    region: 'Africa',
    example: '90 11 23 45',
  },
  {
    name: 'Tokelau',
    dial_code: '+690',
    code: 'TK',
    region: 'Oceania',
    example: '7290',
  },
  {
    name: 'Tonga',
    dial_code: '+676',
    code: 'TO',
    region: 'Oceania',
    example: '771 5123',
  },
  {
    name: 'Trinidad and Tobago',
    dial_code: '+1868',
    code: 'TT',
    region: 'North America',
    example: '291 1234',
  },
  {
    name: 'Tunisia',
    dial_code: '+216',
    code: 'TN',
    region: 'Africa',
    example: '20 123 456',
  },
  {
    name: 'Turkey',
    dial_code: '+90',
    code: 'TR',
    region: 'Asia',
    example: '501 234 56 78',
  },
  {
    name: 'Turkmenistan',
    dial_code: '+993',
    code: 'TM',
    region: 'Asia',
    example: '65 123456',
  },
  {
    name: 'Turks and Caicos Islands',
    dial_code: '+1649',
    code: 'TC',
    region: 'North America',
    example: '231 1234',
  },
  {
    name: 'Tuvalu',
    dial_code: '+688',
    code: 'TV',
    region: 'Oceania',
    example: '901234',
  },
  {
    name: 'Uganda',
    dial_code: '+256',
    code: 'UG',
    region: 'Africa',
    example: '712 345678',
  },
  {
    name: 'Ukraine',
    dial_code: '+380',
    code: 'UA',
    region: 'Europe',
    example: '50 123 4567',
  },
  {
    name: 'United Arab Emirates',
    dial_code: '+971',
    code: 'AE',
    region: 'Asia',
    example: '50 123 4567',
  },
  {
    name: 'United Kingdom',
    dial_code: '+44',
    code: 'GB',
    region: 'Europe',
    example: '7400 123456',
  },
  {
    name: 'United States',
    dial_code: '+1',
    code: 'US',
    region: 'North America',
    example: '(555) 123-4567',
  },
  {
    name: 'Uruguay',
    dial_code: '+598',
    code: 'UY',
    region: 'South America',
    example: '94 231 234',
  },
  {
    name: 'Uzbekistan',
    dial_code: '+998',
    code: 'UZ',
    region: 'Asia',
    example: '91 234 56 78',
  },
  {
    name: 'Vanuatu',
    dial_code: '+678',
    code: 'VU',
    region: 'Oceania',
    example: '591 2345',
  },
  {
    name: 'Venezuela',
    dial_code: '+58',
    code: 'VE',
    region: 'South America',
    example: '412 1234567',
  },
  {
    name: 'Vietnam',
    dial_code: '+84',
    code: 'VN',
    region: 'Asia',
    example: '91 234 56 78',
  },
  {
    name: 'Virgin Islands, British',
    dial_code: '+1284',
    code: 'VG',
    region: 'North America',
    example: '300 1234',
  },
  {
    name: 'Virgin Islands, U.S.',
    dial_code: '+1340',
    code: 'VI',
    region: 'North America',
    example: '642 1234',
  },
  {
    name: 'Wallis and Futuna',
    dial_code: '+681',
    code: 'WF',
    region: 'Oceania',
    example: '82 12 34',
  },
  {
    name: 'Yemen',
    dial_code: '+967',
    code: 'YE',
    region: 'Asia',
    example: '712 345 678',
  },
  {
    name: 'Zambia',
    dial_code: '+260',
    code: 'ZM',
    region: 'Africa',
    example: '95 5123456',
  },
  {
    name: 'Zimbabwe',
    dial_code: '+263',
    code: 'ZW',
    region: 'Africa',
    example: '71 234 5678',
  },
]
export const getCountryNameByCode = (code: string): string | undefined => {
  if (!code) return undefined
  const country = phoneNumbers.find((country) => country.code.toLowerCase() === code.toLowerCase())
  return country ? country.name : undefined
}
export const getCodeByCountryName = (name: string): string | undefined => {
  if (!name) return undefined
  const country = phoneNumbers.find((country) => country.name.toLowerCase() === name.toLowerCase())
  return country ? country.code : undefined
}

/** Pre-built options array for ModalSelect with showCountryFlag. */
export const countrySelectOptions = phoneNumbers.map((c) => ({
  value: c.code,
  label: c.name,
  countryCode: c.code.toLowerCase(),
}))

/** Returns lowercase ISO code from country name. */
export const getCountryCode = (countryName: string): string => {
  const country = phoneNumbers.find((c) => c.name.toLowerCase() === countryName.toLowerCase())
  return country ? country.code.toLowerCase() : ''
}
